import { isEmpty } from 'lodash';

const checkFormUpsertValidation = ({ formField, isShowParentAccount, errorFields }) => {
  let isValid = false;

  isValid =
    !isEmpty(formField?.platform) &&
    !isEmpty(formField?.accountId) &&
    !isEmpty(formField?.storeName) &&
    !isEmpty(formField?.accountType) &&
    isEmpty(errorFields);

  if (isShowParentAccount) isValid = isValid && !isEmpty(formField?.parentAccount);

  return isValid;
};

export default checkFormUpsertValidation;
